import { CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA, NgModule, Provider, forwardRef } from '@angular/core';
import { AppComponent } from './app.component';
import { CoreFlcModule } from './core-flc/core-flc.module';
import { FlcModule } from './flc/flc.module';
import { FileUploaderModule } from './file-uploader/file-uploader.module';
import { MapOpenlayersModule } from './map-openlayers/map-openlayers.module';
import { UtilsFlcModule } from './utils-flc/utils-flc.module';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ApiInterceptor } from './interceptor/api-interceptor';
import { ErrorInterceptor } from './interceptor/error-interceptor';

export const API_INTERCEPTOR_PROVIDER: Provider = {
    provide: HTTP_INTERCEPTORS,
    useExisting: forwardRef(() => ApiInterceptor),
    multi: true
  };
export const API_ERROR_INTERCEPTOR_PROVIDER: Provider = { 
    provide: HTTP_INTERCEPTORS,
    useClass: ErrorInterceptor, 
    multi: true 
}

@NgModule({
    declarations: [
        AppComponent
        ],
    bootstrap: [AppComponent],
    imports: [
        CoreFlcModule,
        FlcModule,
        UtilsFlcModule,
        FileUploaderModule,
        MapOpenlayersModule
    ],
    providers: [
        ApiInterceptor,
        API_INTERCEPTOR_PROVIDER,
        API_ERROR_INTERCEPTOR_PROVIDER
    ],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA,
        NO_ERRORS_SCHEMA
    ]
})
export class AppModule { }
